import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Form, Field } from 'react-final-form';
import { ToastContainer, notify } from '../../libraries/notifications';
import {capitalize, uuidv4, isEmptyObject,getOwner} from '../../libraries/utils';

import config from '../../config';

import { history } from '../../routes';

import LayoutSmall from '../../components/layout/LayoutSmall';
import Icon from '../../libraries/icons';
import SearchInput from '../../components/forms/SearchInput';
import Button from '../../components/commons/Button';
import PrescriptionCard from '../../components/customs/PrescriptionCard';
import MedicamentCartElement from '../../components/customs/MedicamentCartElement';

import medicamentsActions from '../../context/medicaments/actions';
import prescriptionsActions from '../../context/prescriptions/actions';


class PurchaseMedicamentSearch extends React.Component {
  constructor(props) {
    super(props);
    this.t = this.props.t;
    this.state = {
      search: "",
      medicaments: [],
      order_medicaments: [],
      prescriptions: [],
      order_prescriptions: [],
      renderRecetas: false,
      prescription: null
    }
  }
  
  componentDidMount() {
    //this.getVademecum();
    if (!isEmptyObject(this.props.location.state)) { 
      const { pharmacy, prescriptions, medicaments } = this.props.location.state;
      this.setState({ 
        pharmacy, 
        order_prescriptions:prescriptions ? prescriptions : [],
        order_medicaments:medicaments ? medicaments : [] 
      });
      this.getPrescriptions()
    } else {
      console.error("no medicaments")
    }
  }

  getVademecum = async ()=> {
      await this.props.onGetAllMedicaments()
      const { medicaments } = this.props;
      if (medicaments.error) { 
        notify(this.t(medicaments.error.message));
      } else {
        this.setState({ medicaments: medicaments.items });
      }    
  }

  getPrescriptions = async () => {
    const params = { target: getOwner(this.props.auth.user), status: config.PRESCRIPTIONS.STATUS.ACTIVE  }

    await this.props.onGetAllPrescriptions(params)
    const { prescriptions } = this.props;
    if (prescriptions.error) { 
      notify(this.t(prescriptions.error.message));
    } else {
      const already_in_order = this.state.order_prescriptions.map(p => p.id)
      const prescriptions_filtered = prescriptions.items.filter(p => !already_in_order.includes(p.id) && p.type === "pharmacy")

      this.setState({ prescriptions: prescriptions_filtered });
    }    
  }

  getPrescription = async (id) => {
    console.log('GET PRESCRIPTION');
    if (id) {
      await this.props.onGetPrescription(id)
      const prescription = this.props.prescriptions
      if (prescription.error){
        notify(this.t(prescription.error.message));
      } else {
        const prescription = this.props.prescription;
        this.setState({ prescription: prescription.item })
      } 
    }
  }
  
  onSearch = async values => {
    let params = { }
    let search = values.search
    if (search && search !== "") params.where = { custom: { name: `%${search}`, comparison: 'OR',  drug: `%${search}` } };
    params.page_num = 1
    params.page_size = 25
    await this.props.onGetAllMedicaments(params)
    const { medicaments } = this.props;
    if (medicaments.error) {
      notify(this.t(medicaments.error.message));
    } else {
      this.setState({ medicaments: medicaments.items });
    }
  }

  addToCart = (medicament)=>{
    let medicaments = [...this.state.order_medicaments]

    if(this.state.order_medicaments.some(m => m.id === medicament.id)){
      medicaments = medicaments.map(m => {
        if(m.id === medicament.id){
          m.quantity += 1
        }
        return m
      })
    } else {
      const quant_medicament = {...medicament, ...{quantity:1, autoFocus:false}}
      medicaments = [...medicaments, quant_medicament]
    }

    history.push({
      pathname: config.ROUTES.PURCHASES.CART,
      state: {
        pharmacy:this.state.pharmacy,
        prescriptions: this.state.order_prescriptions,
        medicaments
      }
    })
  }

  addPrescriptionToCart = async (prescription)=>{
    console.log("___prescription_id", prescription.id)
    await this.getPrescription(prescription.id)
    history.push({
      pathname: config.ROUTES.PURCHASES.CART,
      state: {
        pharmacy: this.state.pharmacy,
        prescriptions: [...this.state.order_prescriptions, this.state.prescription],
        medicaments: [...this.state.order_medicaments]
      }
    })
  }

  gotoBack = () => {
    history.push({
      pathname: config.ROUTES.PURCHASES.CART,
      state: {
        pharmacy: this.state.pharmacy,
        prescriptions: this.state.order_prescriptions,
        medicaments: this.state.order_medicaments,
      }
    })
  }

  render() {
    const {medicaments, prescriptions, renderRecetas} = this.state 
    return (
      <LayoutSmall
        main={{ className: " bg-base-200"}}
        header={{ 
          title: this.t("Medicamentos"),
          left: { icon: 'arrow_left', action: () => {this.gotoBack()} },
        }}
        container={{ className: "px-0"}}
      >
        <ToastContainer/>
        <section className="bg-primary pb-12">
          <div className="px-4 flex gap-4 max-w-lg mx-auto">
            <Button 
              className={"btn-secondary btn-sm flex-1 " + (!renderRecetas ? "active": "")}
              title={this.t("Venta Libre")}
              onClick={()=>{this.setState({renderRecetas:false})}}
            />
            <Button
              className={"btn-secondary btn-sm flex-1 " + (renderRecetas ? "active": "")}
              title={this.t("Receta")}
              onClick={()=>{this.setState({renderRecetas:true})}}
            />
          </div>
        </section>
        <section className="section-card">
          {renderRecetas ? (
            () => {
              /* Medicamentos con receta */
              return (
                <>
                  {!this.props.prescriptions.loading && prescriptions.length === 0 && (
                    <div className="text-center p-10">
                      <Icon className="h-24 w-24 mx-auto mb-3" name="clean_inside" />
                      <h4 className="mb-1">{this.t("No hay más prescripciones activas")}</h4>
                    </div>
                  )}
                  {prescriptions && prescriptions.map((prescription, index) => {
                    if(!this.state.order_prescriptions.some(p => p.id === prescription.id)){
                      console.log("prescription",prescription)
                      if(!prescription.json_data.indications){
                        return(
                          <PrescriptionCard
                            key={index}
                            prescription={prescription}
                            left={true}
                            onClick={()=> this.addPrescriptionToCart(prescription)}
                          />
                        )
                      }
                    }
                  })
                  }
                </>             
              )
            }
          )() : (
            ()=> {
              /* Medicamentos sin recetas */
              return (
                <>
                  <Form initialValues={{}} onSubmit={this.onSearch}>
                    {({ handleSubmit, form, submitting, pristine, values }) => (
                      <form onSubmit={handleSubmit} className="w-full max-w-lg mx-auto">
                          <Field name="search" component={SearchInput} placeholder={this.t("Buscar")} onClick={this.onSearch} />                
                      </form>
                    )}
                  </Form>
                  {!this.state.renderRecetas && !this.props.medicaments.loading && medicaments.length === 0 && (
                    <div className="text-center p-10">
                      <h4 className="mb-1">{this.t("Ingrese una busqueda")}</h4>
                    </div>
                  )}
                  <ul className="mt-5">
                    { !this.state.renderRecetas && medicaments.map((medicament, index) => 
                      <MedicamentCartElement
                        className="border-b py-2"
                        key={index}
                        selectable={true}
                        medicament={medicament}
                        onClick={() => this.addToCart(medicament)}
                      />
                    )}
                  </ul>
                </>
              )
            }
          )()}
        </section>
      </LayoutSmall>      
    ) 
  }
}

const mapStateToProps = state => {
  return {
    auth: state.users.auth,
    medicaments: state.medicaments.list,
    prescriptions: state.prescriptions.list,
    prescription: state.prescriptions.current,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onGetAllMedicaments: (params) => dispatch(medicamentsActions.getAll(params)),
    onGetAllPrescriptions: (params) => dispatch(prescriptionsActions.getAll(params)),
    onGetPrescription: (id) => dispatch(prescriptionsActions.get(id)),
    
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(PurchaseMedicamentSearch));
